import axios from 'axios'
import type { AddonParamData, AddonProduct, AddonProductEnum, GetAvailableAddonOffersRequest, GetAvailableAddonOffersResponse, OfferAddon, SimpleItem } from 'BrokerTsLib/src/dtos'
import type { GenericMutationOptions } from 'BrokerTsLib/src/hooks'
import { useMutation } from 'react-query'

import { useUrl } from '.'
import { Apis } from '../appSettings'

export const useGetAddonOffers = (paramsId: string, options?: GenericMutationOptions<OfferAddon[]>) => {
  const url = useUrl(Apis.offerAddon)

  return useMutation(['useGetAddonOffers', paramsId]
    , () => axios.get<OfferAddon[]>(`${url}/GetAddonOffers?paramsId=${paramsId ?? 0}`)
    , options)
}

export const useCalculateAddonOffers = () => {
  const url = useUrl(Apis.offerAddon)
  return useMutation((data: { hubId: string | null, offerIds?: number[], forceCalculation?: boolean, paramsId?: string }) =>
    axios.post<OfferAddon[]>(`${url}/CalculateAddonOffers`, data))
}

export const useSelectVariant = () => {
  const url = useUrl(Apis.offerAddon)
  return useMutation((data: { activeOfferId: number, productId: number }) =>
    axios.post<number>(`${url}/SelectVariant`, data))
}

export const useChangeParams = () => {
  const url = useUrl(Apis.offerAddon)
  return useMutation((data: { activeOfferId: number, parameterValues: AddonParamData[] }) =>
    axios.post<void>(`${url}/ChangeParams`, data))
}

export const useChangePrice = () => {
  const url = useUrl(Apis.offerAddon)
  return useMutation((data: { offerId: number, price: number }) =>
    axios.post<OfferAddon>(`${url}/ChangePrice`, data))
}

export const useSetAddonSelectedVariant = () => {
  const url = useUrl(Apis.offerAddon)
  return useMutation((data: { activeOfferId: number, selected: boolean }) =>
    axios.post<void>(`${url}/SetAddonSelectedVariant`, data))
}

export const useSelectOfferAddon = () => {
  const url = useUrl(Apis.offerAddon)
  return useMutation((data: { mainOfferId?: number, addonOfferId?: number, term?: string }) =>
    axios.post<void>(`${url}/SelectOfferAddon`, data))
}

export const useGetAddonProductEnums = (onSuccess?: (data: AddonProductEnum[]) => void) => {
  const url = useUrl(Apis.offerAddon)

  const mut = (data: { offerId: number, riskVariantId: number, changedParams: AddonParamData[], filterOutput?: boolean, mainInsurerOfferId?: number }) =>
    axios.post<AddonProductEnum[]>(`${url}/GetAddonProductEnums`, data)

  return useMutation({
    mutationFn: mut,
    onSuccess: (({ data }) => { onSuccess?.(data) })
  })
}

export const useGetAddonRiskVariantProducts = () => {
  const url = useUrl(Apis.offerAddon)

  return useMutation((data: { offerId: number, riskVariantId: number }) =>
    axios.post<SimpleItem[]>(`${url}/GetAddonRiskVariantProducts?offerId=${data.offerId}&riskVariantId=${data.riskVariantId}`))
}

export const useGetAddonParamValues = () => {
  const url = useUrl(Apis.offerAddon)

  return useMutation((data: { mainOfferId: number, addonOfferId: number, paramName: string }) =>
    axios.get<AddonProduct[]>(`${url}/GetAddonParamValues?mainOfferId=${data.mainOfferId}&addonOfferId=${data.addonOfferId}&paramName=${data.paramName}`))
}

export const useGetAvailableAddonOffers = () => {
  const url = useUrl(Apis.offerAddon)

  return useMutation((data: GetAvailableAddonOffersRequest) =>
    axios.post<GetAvailableAddonOffersResponse[]>(`${url}/GetAvailableAddonOffers`, data))
}